import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: закрыт балун карты по выбранному пину.
 */
export function trackMapBalloonClose(newbuildingId: string): void {
  ca('eventSite', {
    action: 'close',
    category: 'Promo',
    label: 'project_map_pin',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
            },
          ],
        },
      }),
    ],
  });
}
